import React from 'react';
import Page from 'src/components/Page';
import { Header } from 'src/components/Headers';
import { Container, Divider, makeStyles, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ServiceClient } from 'src/constants/modules/serviceClient';
import { SERVICE_CLIENT_AUTH } from 'src/constants/permissions';
import { useServiceClient } from 'src/hooks';
import useAuth from 'src/hooks/useAuth';
import { ServiceClientForm } from 'src/components/ServiceClients/Form';
import type { TServiceClientFormValues } from 'src/components/ServiceClients/Form';
import { buildCreateServiceClientBody } from 'src/components/ServiceClients/Form/buildCreateServiceClientBody';
import { SnackbarAlert } from 'src/components/Alerts/components/System/components/SnackbarAlert';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const ServiceClientCreateView = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const { user } = useAuth();
    const { createServiceClient } = useServiceClient();
    const { customAlert } = SnackbarAlert();

    const handleSubmit = async (values: TServiceClientFormValues) => {
        if (!user?._id) return;
        const body = buildCreateServiceClientBody(values, { createdBy: user._id });
        const created = await createServiceClient(body);
        if (created?._id) {
            customAlert(t('SnackBar.LeadCreated'), 'success');
            history.push(`/management/service-clients/${created._id}`);
        }
    };

    return (
        <Page className={classes.root} title={t('serviceClients.Create')}>
            <Container maxWidth="lg">
                <Header
                    module={ServiceClient.name}
                    route={ServiceClient.route}
                    crud={{ goBack: true }}
                    permission={SERVICE_CLIENT_AUTH}
                    title={t('serviceClients.Create')}
                />
                <Divider />
                <Box mt={3}>
                    <ServiceClientForm mode="create" onSubmit={handleSubmit} />
                </Box>
            </Container>
        </Page>
    );
};
